import { render, staticRenderFns } from "./DetailFixPriceRoute.vue?vue&type=template&id=0e55a6c0&"
import script from "./DetailFixPriceRoute.vue?vue&type=script&lang=js&"
export * from "./DetailFixPriceRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports